import React from "react";
import styles from "./RecommendationsSection.module.scss";
import recommendationImage from "../../../assets/images/open-call-image.jpg";

const RecommendationsSection = () => {
  return (
    <div className={styles.recommendationsSection}>
      <div className="container">
        <h2 className={styles.title}>Recommendations</h2>
        <div className={styles.list}>
          {Array.from(Array(2), (_, index) => (
            <div className={styles.recommendationCard} key={index}>
              <div className={styles.recommendationTitle}>
                Title Of The Recommendation
              </div>
              <div className={styles.recommendationBody}>
                <p>
                  Contrary to popular belief, Lorem Ipsum is not simply random
                  text. It has roots in a piece of classical Latin literature
                  from 45 BC, making it over 2000 years old. Richard McClintock.
                  Contrary to popular belief, Lorem Ipsum is not simply random
                  text. It has roots in a piece of classical Latin literature
                  from. Contrary to popular belief, Lorem Ipsum is not simply
                  random text Contrary to popular belief, Lorem Ipsum is not
                  simple text.Contrary to popular belief, Lorem Ipsum is not
                  simply random text. It has roots in a piece of classical Latin
                  literature from 45 BC, making it over 2000 years old. Richard
                  McClintock. Contrary to popular belief, Lorem Ipsum is not
                  simply random text. It has roots in a piece of classical Latin
                  literature from. Contrary to popular belief, Lorem Ipsum is
                  not simply random text Contrary to popular belief, Lorem Ipsum
                  is not simple ...
                </p>
                <div className={styles.withImage}>
                  <img src={recommendationImage} alt="some text" />
                  <img src={recommendationImage} alt="some text" />
                </div>
                <p>
                  Contrary to popular belief, Lorem Ipsum is not simply random
                  text. It has roots in a piece of classical Latin literature
                  from 45 BC, making it over 2000 years old. Richard McClintock.
                  Contrary to popular belief, Lorem Ipsum is not simply random
                  text. It has roots in a piece of classical Latin literature
                  from. Contrary to popular belief, Lorem Ipsum is not simply
                  random text Contrary to popular belief, Lorem Ipsum is not
                  simple text.Contrary to popular belief, Lorem Ipsum is not
                  simply random text. It has roots in a piece of classical Latin
                  literature from 45 BC, making it over 2000 years old. Richard
                  McClintock. Contrary to popular belief, Lorem Ipsum is not
                  simply random text. It has roots in a piece of classical Latin
                  literature from. Contrary to popular belief, Lorem Ipsum is
                  not simply random text Contrary to popular belief, Lorem Ipsum
                  is not simple ...
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecommendationsSection;
